import 'core-js/stable/index.js';
import 'regenerator-runtime/runtime.js';
// import 'whatwg-fetch';
/* Disabled due to issues with Chrome and IntersectionObserver API, use lazysizes instead of lozad/intersection-observer */
/*
import 'intersection-observer';
*/
import 'lazysizes';

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.throttleDelay = 66;
window.lazySizesConfig.loadMode = 2;
window.lazySizesConfig.ricTimeout = 150;
//
